import { render, staticRenderFns } from "./WarehouseReceiptInfoCard.vue?vue&type=template&id=0472f863&scoped=true"
import script from "./WarehouseReceiptInfoCard.vue?vue&type=script&lang=js"
export * from "./WarehouseReceiptInfoCard.vue?vue&type=script&lang=js"
import style0 from "./WarehouseReceiptInfoCard.vue?vue&type=style&index=0&id=0472f863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472f863",
  null
  
)

export default component.exports